import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import CartItemList from './CartItemList';
import CartTotal from './CartTotal';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

const OFFER = (props) => {
    let Offers = props.offers.map((post, i)=>{
        return (
            <div className="custom-control custom-radio" key={i}>
                <div className="custom-control-label" htmlFor="customCheck4">
                    <span className="coupon-code">{post.CODE}</span>
                    <h5 className="pt-1">{post.NAME}</h5>
                </div>
                <span className="apply-coupon badge badge-light"><button className="text-upper font-weg-600" onClick={()=>{props.AddCouponToCart(props.cartTOTAL,post.MIN_PURCHASE,post.ID,post.CODE,post.TYPE,post.VALUE,post.TEXT)}}>Apply</button></span>
            </div>
        );
    });

    return (
        <div>
            {Offers}
        </div>
    );
}

class Cart extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOADING: true, 
            LOCATION: this.props.location.pathname,
            ITEMS: [],
            OFFERS:[],
            CartCount: 0,
            cartEMPTY: 'Y',
            AnikZai: '',
            couponSUCCESS: '',
            couponFAILURE: '',
            offerTOTAL: 0,
            CUSTOMER_DET: '',
            MIN_ORDER: 0,
            DEL_DATE: '',
            DEL_TIME: ''
        };
    }

    fetchCustomerProfile(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/profile_api2.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                            
            that.setState({ LOADING:false, CUSTOMER_DET:CUSTOMER_DET  });
        });
    }

    fetchCartMenu(mode,items,offerID,offerCODE) {
        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');

        if(customer==undefined || customer=='undefined')
            customer = '';
        
        var that = this;
        fetch('https://m.donedelivery.in/api/cartitems_api.php?mode='+mode+'&items='+items+'&customer='+customer+'&offer_id='+offerID+'&offer_code='+offerCODE,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
            
            if(result.APPLY_OFFER!=='' && result.APPLY_OFFER!==undefined && result.APPLY_OFFER!=='undefined')
            {
                if(result.APPLY_OFFER=='N')
                    localStorage.removeItem('OFFER_APPLIED');
            }
                
            that.setState({ LOADING:false, ITEMS:result.ITEMS, OFFERS:result.OFFERS, cartEMPTY:'N', CUSTOMER_DET:CUSTOMER_DET, MIN_ORDER:result.MIN_ORDER, DEL_DATE:result.DEL_DATE, DEL_TIME:result.DEL_TIME });
        });
    }

    updateCart = () =>{
        console.log('CART UPDATED');
        var that = this;

        let cartEMPTY = 'Y';
        let cart = localStorage.getItem('cartData');
        let cartData = JSON.parse(cart);
        if(cart !== null && cart!=='{}')
        {
            cartEMPTY = 'N';
        }
        
        that.setState({ CartCount:1, cartEMPTY:cartEMPTY });
    }

    AddCouponToCart = (cartTOTAL,minPURCHASE,offerID,offerCODE,offerTYPE,offerVALUE,offerTEXT) => {
        if(parseFloat(cartTOTAL)>=parseFloat(minPURCHASE))
        {
            let OFFER = 0;
            if(offerTYPE=='PER')
                OFFER = (parseFloat(cartTOTAL) * parseFloat(offerVALUE))/100;
            else if(offerTYPE='DIS')
                OFFER = offerVALUE;

            let msg = '';
            if(OFFER!=0 && OFFER!='0')
            { 
                msg = `<p className="font-weg-600 font-size-13 text-upper mb-05">'${offerCODE}'`+' applied</p> <p className="mb-05 font-size-12 text-danger">&#8377; '+`${OFFER}`+'</p> <p className="font-size-12"> savings with this coupon</p>';
            }
            else
            {
                msg = `<p className="font-weg-600 font-size-13 text-upper mb-05">'${offerCODE}'`+' applied</p> <p className="mb-05 font-size-12 text-danger">'+`${offerTEXT}`+'</p> <p className="font-size-12"> free with this coupon</p>';
            }

            let msg2 = offerCODE;

            localStorage.setItem('OFFER_APPLIED',offerID+'~~**~~'+offerCODE);

            this.setState({ couponSUCCESS:msg, offerTOTAL:OFFER, offerAPPLIED:msg2 });
            $('#ModalCouponList').modal('hide');
            $('#couponSuccessModal').modal('show');
        }
        else
        {
            localStorage.removeItem('OFFER_APPLIED');
            this.setState({ couponFAILURE:'Cart value is not sufficient'});
            $('#ModalCouponList').modal('hide');
            $('#couponFailureModal').modal('show');
        }
    }

    RemoveCouponFromCart = () => {
        localStorage.removeItem('OFFER_APPLIED');
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        let itemLIST = '';
        let cart = localStorage.getItem('cartData');
        let cartData = JSON.parse(cart);
        if(cart !== null && cart!=='{}')
        {
            Object.keys(cartData).forEach(function(key) {
                let cart_id = key.split('~~**~~');
                let itemID = cart_id[0];
                let itemCOUNT = cartData[key];
                itemLIST += itemID+'|'+itemCOUNT+',';
            });    
        }

        if(itemLIST!='')
        {
            itemLIST = itemLIST.substring(0, itemLIST.length-1);

            let OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
            if(OFFER_APPLIED==null) 
                OFFER_APPLIED = '';
            
            let offerID = '';
            let offerCODE = '';
                            
            if(OFFER_APPLIED!='')
            {
                let OFFER_APPLIED2 =  OFFER_APPLIED.split('~~**~~');
                offerID =  OFFER_APPLIED2[0];
                offerCODE =  OFFER_APPLIED2[1];
            }
            
            this.fetchCartMenu('ITEMS',itemLIST,offerID,offerCODE);
        }
        else
        {
            var customer = localStorage.getItem('userData');
            this.fetchCustomerProfile('PROFILE',customer);
        }
    }

    handleEmptyCart = () => {
        $('#emptyCart').modal('show');
    }

    handleEmptyCartNow = () => {
        localStorage.removeItem('cartCIRCLE');
        localStorage.removeItem('cartData');
        localStorage.removeItem('AnikZai');
        localStorage.removeItem('cartVendorID');
        localStorage.removeItem('cartVendorName');
        localStorage.removeItem('cartVendorTypeID');

        let cartEMPTY = 'Y';
        let cart = localStorage.getItem('cartData');
        let cartData = JSON.parse(cart);
        if(cart !== null && cart!=='{}')
        {
            cartEMPTY = 'N';
        }
        
        this.setState({ CartCount:1, cartEMPTY:cartEMPTY });
    }

    handlePopupClick = (e) => {
        e.preventDefault();
        $('#popupCart').modal('show');
    }

    handleClickSpecialInstructionsClear = () => {
        localStorage.removeItem('AnikZai');
        this.setState({ AnikZai:'' });
    }

    handleClickAnikZaiInstructionsAdd = (e) => {
        let special_instructions = e.target.value;
        localStorage.setItem('AnikZai',special_instructions);
        
        //console.log(special_instructions);

        this.setState({ AnikZai:special_instructions });
    }

    handleClickIncreement = (id,unit,cartCount)=>{
        let cartTotalCount = 0;
        cartCount = cartCount + 1;

        let cart = localStorage.getItem('cartData');
        var that = this;
        var cartData = JSON.parse(cart);
        Object.keys(cartData).forEach(function(key) {
            let cart_id = key.split('~~**~~');
            if(cart_id[0]==id)
                cartTotalCount += cartData[key];

            if(cart_id[0]==id && unit==cart_id[1])
                cartData[key] = cartCount;
        });
        cartTotalCount += 1;

        localStorage.setItem('cartData', JSON.stringify(cartData));
        this.setState({ CartCount:1});
    }

    handleClickDecreement = (id,unit,cartCount)=>{
        
        cartCount = (cartCount!=0)?cartCount - 1:0;
        let cart = localStorage.getItem('cartData');
        var that = this;
        var cartData = JSON.parse(cart);
        Object.keys(cartData).forEach(function(key) {
            let cart_id = key.split('~~**~~');
            if(cart_id[0]==id && unit==cart_id[1])
            {
                if(cartCount==0)
                    delete cartData[key];
                else
                    cartData[key] = cartCount;
            }
        });

        localStorage.setItem('cartData', JSON.stringify(cartData));
        cart = localStorage.getItem('cartData');
        if(cart === null || cart ==='{}')
        {
            localStorage.removeItem('cartCIRCLE');
            localStorage.removeItem('AnikZai');
            localStorage.removeItem("cartData");
            localStorage.removeItem('cartVendorID');
            localStorage.removeItem('cartVendorName');
            localStorage.removeItem('cartVendorTypeID');
        }

        this.CalculateCartOfferExistence();
    }

    CalculateCartOfferExistence = () =>{

        let itemLIST = '';
        let cart = localStorage.getItem('cartData');
        let cartData = JSON.parse(cart);
        if(cart !== null && cart!=='{}')
        {
            Object.keys(cartData).forEach(function(key) {
                let cart_id = key.split('~~**~~');
                let itemID = cart_id[0];
                let itemCOUNT = cartData[key];
                itemLIST += itemID+'|'+itemCOUNT+',';
            });    
        }

        if(itemLIST!='')
        {
            itemLIST = itemLIST.substring(0, itemLIST.length-1);

            let OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
            if(OFFER_APPLIED==null) 
                OFFER_APPLIED = '';
            
            let offerID = '';
            let offerCODE = '';
            if(OFFER_APPLIED!='')
            {
                let OFFER_APPLIED2 =  OFFER_APPLIED.split('~~**~~');
                offerID =  OFFER_APPLIED2[0];
                offerCODE =  OFFER_APPLIED2[1];
            }
        
            this.fetchCartMenu('ITEMS',itemLIST,offerID,offerCODE);
        }
        else
        {
            this.setState({ CartCount:1});
        }
    }

    render() { 

        //localStorage.removeItem("userData");
        //console.log(localStorage.getItem('userData'));

        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'CART';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = '';

        let cart = localStorage.getItem('cartData');
        let cartData = JSON.parse(cart);

        if(cart !== null && cart!=='{}')
        {
            let LIST = this.state.ITEMS;
            if(LIST!='')
            {
                Object.keys(cartData).forEach(function(key) {
                    let cart_id = key.split('~~**~~');

                    if(LIST.length>0)
                    {
                        LIST.map(id =>{

                            if(cart_id[0]==id.ITEMID)
                            {
                                //if(id.NEXTAVAILABLE!='')
                                if(id.AVAILABLE_QTY==='0' || id.AVAILABLE_QTY===0)
                                {
                                    delete cartData[key];
                                }
                            }
                        });
                    }
                });
            }

            localStorage.setItem('cartData', JSON.stringify(cartData));
        }

        cart = localStorage.getItem('cartData');
        cartData = JSON.parse(cart);
        let cartItemCount = 0;
        if(cart !== null && cart!=='{}')
        {
            Object.keys(cartData).forEach(function(key) {
                let itemCOUNT = cartData[key];
                cartItemCount = cartItemCount + itemCOUNT;
            });    
        }
        
        let props = {
            items: this.state.MENU,
            updateCart: this.updateCart
        };

        let logged = 'N';
        if(localStorage.getItem('userData')) 
            logged = 'Y';

        let cartTOTAL = 0;

        let anikZaiInstructions = localStorage.getItem('AnikZai');
        if(anikZaiInstructions==null) 
            anikZaiInstructions = '';
        
        let OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
        if(OFFER_APPLIED==null) 
            OFFER_APPLIED = '';
        
        let offerID = '';
        let offerAPPLIED = '';
        if(OFFER_APPLIED!='')
        {
            let OFFER_APPLIED2 =  OFFER_APPLIED.split('~~**~~');
            offerID =  OFFER_APPLIED2[0];
            offerAPPLIED =  OFFER_APPLIED2[1];
        }

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    {this.state.cartEMPTY=='N' &&
                    <div className="section full mt-2">
                        <div className="section-title d-flex justify-content-between pb-1 pr-2 pl-2 medium font-weg-400"> {cartItemCount} item{cartItemCount>1?'s':''} 
                            <span className="badge text-danger font-weg-400" style={{'cursor':'pointer'}} onClick={()=>{this.handleEmptyCart()}} >Empty Cart</span>
                        </div>
                        <div className="cart-list-items">
                            <ul className="listview image-listview">
                                {
                                this.state.ITEMS.map(item=>{
                                    let cartCount = 0; //this.state.cartCount;

                                    let currentITEM = item.ID;
                                    let cart = localStorage.getItem('cartData');
                                    if (cart !== null) {
                                        let cartData = JSON.parse(cart);
                                        Object.keys(cartData).forEach(function(key) {
                                            let id = key.split('~~**~~');
                                            if(id[0]==currentITEM)  
                                                cartCount += cartData[key];
                                        });
                                    }

                                    let itemTOTAL = parseFloat(item.RATE) * parseFloat(cartCount);
                                    cartTOTAL = parseFloat(cartTOTAL) + parseFloat(itemTOTAL);
                                    
                                    if(cartCount>0)
                                    {
                                        return (
                                            <li key={item.ID}>
                                                <div className="item">
                                                    <img src={item.PIC} alt={item.NAME} className="image" />
                                                    <div className="in">
                                                        <div className="item-name font-size-12 font-weg-500 text-dgrey pr-1">{item.NAME} ( per {item.UNIT})
                                                            <div className="final-price text-danger font-size-14 font-weg-500">&#8377; {item.RATE}</div>
                                                        </div>
                                                        <div className="cart-add-btn add-btn-inc mt-0">
                                                            <input type="button" onClick={()=>{this.handleClickDecreement(item.ID,item.UNIT,cartCount)}} value="-" className="qtyminus" />
                                                            <input type="text" value={cartCount} readOnly className="qty" />
                                                            <input type="button" onClick={()=>{this.handleClickIncreement(item.ID,item.UNIT,cartCount)}}  value="+" className="qtyplus"/>
                                                        </div>
                                                        <span className="badge badge-light font-size-14 font-weg-500">&#8377; {itemTOTAL}</span>
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    }
                                })}
                                <li>
                                    <div className="section-title w-100  d-flex justify-content-between pt-2 pb-2 pr-2 pl-2 medium"> Total 
                                        <span className="font-weg-600">&#8377; {cartTOTAL}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        {logged==='Y' && this.state.OFFERS.length>0 &&
                        <div>
                            {offerAPPLIED!='' &&
                                <div className="section full mt-2">
                                    <ul className="listview image-listview flush transparent mb-1">
                                        <li>
                                            <div className="item bg-white">
                                                <div className="in no-flex font-weg-600 font-size-13 text-upper">
                                                    {offerAPPLIED}
                                                    <br /> <p className="font-size-10 pb-0 text-lgrey p-0 mb-0 mt-05">coupon applied for this bill</p>
                                                </div>
                                                <Link to="#" onClick={this.RemoveCouponFromCart} className="close-button">
                                                    <ion-icon name="close"></ion-icon>
                                                </Link>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            }
                            {offerAPPLIED==='' &&
                                <div className="section full mt-2">
                                    <ul className="listview image-listview flush transparent mb-1">
                                        <li>
                                            <Link to="#" className="item bg-white" data-toggle="modal" data-target="#ModalCouponList">
                                                <div className="in font-weg-600 font-size-13 text-upper">
                                                    Apply Coupon
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            }
                                <div className="modal fade modalbox delivery-coupon" id="ModalCouponList" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title font-size-10 text-upper">Available coupons</h5>
                                                <Link to="#" data-dismiss="modal" className="font-size-10 text-upper">Close</Link>
                                            </div>
                                            <div className="modal-body p-0">
                                                <div className="input-list">
                                                    <OFFER offers={this.state.OFFERS} cartTOTAL={cartTOTAL} AddCouponToCart={this.AddCouponToCart} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal fade dialogbox" id="couponSuccessModal" data-backdrop="static" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header m-0 p-0">
                                                <h5 className="modal-title">&nbsp;</h5>
                                            </div>
                                            <div className="modal-body"> 
                                                <div className="modal-icon text-success mt-0 mb-1">
                                                    <ion-icon name="checkmark-circle"></ion-icon>
                                                </div>
                                                <div dangerouslySetInnerHTML={{ __html: this.state.couponSUCCESS }} />
                                            </div>
                                            <div className="modal-footer">
                                                <div className="btn-inline"> 
                                                    <button type="button" className="btn btn-text-success" data-dismiss="modal">Ok</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal fade dialogbox" id="couponFailureModal" data-backdrop="static" tabIndex="-1" role="dialog">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header m-0 p-0">
                                                <h5 className="modal-title">&nbsp;</h5>
                                            </div>
                                            <div className="modal-body"> 
                                                <div className="modal-icon text-danger mt-0 mb-1">
                                                    <ion-icon name="close-circle"></ion-icon>
                                                </div>
                                                {this.state.couponFAILURE} 
                                            </div>
                                            <div className="modal-footer">
                                                <div className="btn-inline"> 
                                                    <button type="button" className="btn btn-text-danger" data-dismiss="modal">Ok</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        }
                        <div>
                            <div className="delivery-date date-slot">
                                <p className="font-size-12 pt-1 font-weg-500 mt-2 mb-0 pr-2 pl-2">Delivery Date</p>
                                <div className="form-group basic more-locations pt-05">
                                    <div className="input-wrapper">
                                        <p className="form-control text-upper btn  bg-white square custom-select" id="city4">{this.state.DEL_DATE}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="delivery-date time-slot">
                                <p className="font-size-12 pt-1 font-weg-500 mt-2 mb-0 pr-2 pl-2">Delivery Time</p>
                                <div className="form-group basic more-locations pt-05">
                                    <div className="input-wrapper">
                                        <p className="form-control text-upper btn  bg-white square custom-select" id="city4">{this.state.DEL_TIME}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="clear"></div>
                        </div>
                        <div className="pt-0 pr-2 pl-2 pb-4">
                            <div className="col-12 p-0">
                                <div className="anik-jai accordion" id="accordionExample1">
                                    <div className="item">
                                        <div className="accordion-header">
                                            <button className="btn text-danger collapsed mb-0" type="button" data-toggle="collapse" data-target="#accordion1" aria-expanded="false"> ANY SPECIAL INSTRUCTIONS? </button>
                                            <p className="mb-1 pb-05 font-size-11">(Leave with Security, Call before delivery)</p>
                                        </div>
                                        <div id="accordion1" className="accordion-body collapse" data-parent="#accordionExample1">
                                            <div className="accordion-content">
                                                <textarea rows="3" className="square-inputbox form-control square" name="AnikZaiInstructions" id="AnikZaiInstructions" defaultValue={anikZaiInstructions} onChange={(event) => this.handleClickAnikZaiInstructionsAdd(event)} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-upper">
                                    <div className="row">
                                        <div className="col-6"> <Link to='/categories' className="btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-llg btn-block goBack">Add more items</Link> </div>
                                        {this.state.MIN_ORDER<=cartTOTAL &&
                                            <div className="col-6"> <Link to={logged=='Y'?'/checkout':'/login'} className="btn newshadowed font-size-14 square btn-danger btn-llg btn-block">Checkout</Link> </div>
                                        }
                                        {this.state.MIN_ORDER>cartTOTAL &&
                                            <div className="col-6"> <Link to="#" className="btn newshadowed font-size-14 square btn-danger btn-llg btn-block" data-toggle="modal" data-target="#MinOrderRequired" >Checkout</Link> </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade dialogbox" id="MinOrderRequired" data-backdrop="static" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-icon text-danger">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </div>
                                    <div className="modal-body">
                                        <p className="if-no-add">The VENDOR has a minimum order value of {this.state.MIN_ORDER}</p> 
                                    </div>
                                    <div className="modal-footer">
                                        <div className="btn-inline"> 
                                            <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade dialogbox" id="emptyCart" data-backdrop="static" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">&nbsp;</h5>
                                    </div>
                                    <div className="modal-body"> 
                                        You are about to empty the cart. Continue? 
                                    </div>
                                    <div className="modal-footer">
                                        <div className="btn-inline"> 
                                            <button type="button" className="btn btn-text-success" data-dismiss="modal" onClick={this.handleEmptyCartNow}>Yes</button>
                                            <button type="button" className="btn btn-text-danger" data-dismiss="modal">No</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {this.state.cartEMPTY=='Y' &&
                        <div className="section pt-6" style={{textAlign: 'center'}}>
                            <img src="/assets/img/cart-empty.png" alt="empty-cart" className="form-image imaged w200" />
                            <h4 className="size-19">Empty Cart</h4>
                        </div>
                    }
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
  
export default Cart;


// WEBPACK FOOTER //
// ./src/components/Cart.js